import React from 'react'
import { BuyerDetailFormStyle } from './styled'
import {
  Button,
  Image,
  Input,
  Section,
  SelectBox,
  InputTextarea,
  Spinner,
} from '../../components'
import { EMAIL_REGEX } from 'helpers'
import { ICONS } from '../../themes'
import { buyermangeController, countryController } from '../../apiService'
import { ROUTE_PATH, STRING, trimmedString } from '../../helpers'
import { toastActive } from '../../helpers/functions/toastSuccess'
import { toastFail } from '../../helpers/functions/toastFail'

export class BuyerDetailFormContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      optionsCountry: [{ value: 'Thailand', label: 'Thailand' }],
      optionsCountry_time_zone: [{ value: '+07:00', label: '+07:00' }],
      time_zone: { value: '+07:00', label: '+07:00' },
      isEditPageState: true,
      isActive: false,
      canSave: false,
      checkTax: true,
      requireTax: false,
      BuyerListLoading: false,
      statusVerify: '',
      tax_id: '',
      tax_id_require: false,
      company_name: '',
      regis_address: '',
      regis_country: '',
      contact_address: '',
      contact_country: {},
      phone: '',
      phone_require: false,
      fax: '',
      email: '',
      webbsite: '',
      supplier_portal: '',
      admin_buyer_full_name: '',
      admin_buyer_email: '',
      admin_buyer_license: '',

      //validate
      emailValidate: false,
      admin_buyer_emailValie: false,
      admin_buyer_licenseValidate: false,
      tax_idValidate: false,
      requireActive: false,
      emailValid: true,
      formValid: true,

      //loading
      isVerifyLoading: false,
      loading: false,
      loadingPage: false,
    }
  }

  componentDidMount() {
    this.getCountryList()
  }

  _fetchverifyTaxID(id) {
    this.setState({ BuyerListLoading: true, isVerifyLoading: true })
    return buyermangeController()
      .verifyTaxID(id)
      .then(res => {
        this.company(res)
        this.setState({ isVerifyLoading: false, BuyerListLoading: false })
      })
      .finally(() => this.setState({ BuyerListLoading: false }))
  }

  company = e => {
    const rows = Array.isArray(e) ? e : e && Array.isArray(e.data) ? e.data : []
    const data = rows[0]
    if (data && data.JP_TNAME) {
      this.setState({
        company_name: data.JP_TNAME,
        canSave: true,
        checkTax: true,
      })
      return
    }
    this.setState({ canSave: false, checkTax: false })
  }

  getCountryList = async () => {
    try {
      const countryList = await countryController().getListCountry()
      if (countryList) {
        const mapCountryList = countryList.map(country => {
          let timezone = []
          try {
            timezone =
              typeof country.timezone === 'string'
                ? JSON.parse(country.timezone)
                : country.timezone || []
          } catch (error) {
            timezone = []
          }
          return {
            value: country.name,
            label: country.name,
            id: country.id,
            timezone,
          }
        })
        const defaultCountry =
          mapCountryList.find(country => country.value === 'Thailand') ||
          mapCountryList[0]
        const timeZones = (defaultCountry.timezone || []).map(time => ({
          value: time,
          label: time,
        }))
        this.setState({
          optionsCountry: mapCountryList,
          contact_country: defaultCountry,
          optionsCountry_time_zone: timeZones.length
            ? timeZones
            : this.state.optionsCountry_time_zone,
          time_zone: timeZones[0] || this.state.time_zone,
        })
      }
    } catch (error) {
      throw error
    }
  }

  _fetchcreateBuyer(data) {
    // this.setState({ BuyerListLoading: true, loading: true })
    this.setState({ BuyerListLoading: true })
    return buyermangeController()
      .createBuyer(data)
      .then(res => {
        // console.log('res', res)
        if (res.status === 'SendMailSuccess') {
          setTimeout(
            toastActive('User was updated'),
            this.props.history.push(ROUTE_PATH.BUYER_MANAGEMENT.LINK),
            500
          )
        } else if (res.status === 'EmailDuplicate') {
          toastFail(res.message)
          // this.props.history.push(ROUTE_PATH.BUYER_MANAGEMENT.LINK)
        } else if (res.status === 'TaxIDDuplicate') {
          toastFail('Tax ID duplicate')
          // this.props.history.push(ROUTE_PATH.BUYER_MANAGEMENT.LINK)
        }
      })
      .finally(() => this.setState({ BuyerListLoading: false, loading: false }))
  }

  handleUserInput = e => {
    const { name, value } = e.target
    this.setState({ [name]: value }, () => {
      this.validateField(name, value.trim())
      // console.log('value!!!!!!!!!!!!!!!', value)
    })
  }

  handleUserDropdown = optionsRole => {
    this.setState({ contact_country: optionsRole }, () => {
      this.validateField(optionsRole.label, optionsRole.value)
    })
    let time_zone_arr = []
    optionsRole.timezone.map(time => {
      time_zone_arr.push({
        value: time,
        label: time,
      })
    })
    this.setState({
      optionsCountry_time_zone: time_zone_arr,
      time_zone: time_zone_arr[0],
    })
  }

  onClickDropdownTimeZone = optionsTimeZone => {
    this.setState({
      time_zone: { value: optionsTimeZone.value, label: optionsTimeZone.value },
    })
  }

  validateField = (fieldName, value) => {
    const re = /^[0-9\b]+$/
    const status = re.test(value.trim())
    const status_email = RegExp(EMAIL_REGEX).test(value.trim())
    let emailValid = this.state.email
    let admin_buyer_emailValid = this.state.admin_buyer_email

    switch (fieldName) {
      case 'tax_id':
        this.setState({ tax_idValidate: status })
        break
      case 'admin_buyer_license':
        this.setState({ admin_buyer_licenseValidate: status })
        break
      case 'email':
        emailValid = RegExp(EMAIL_REGEX).test(value)
        this.setState({ emailValid: emailValid })
        break
      case 'admin_buyer_email':
        admin_buyer_emailValid = RegExp(EMAIL_REGEX).test(value)
        //console.log('emailValid', emailValid)
        this.setState({ admin_buyer_emailValid: admin_buyer_emailValid })
        break

      default:
        break
    }
  }

  // handleChange = () => {
  //   this.setState(prevState => ({
  //     isActive: !prevState.isActive,
  //   }))
  // }

  Verify = () => {
    if (this.state.tax_id.trim() !== '') {
      this._fetchverifyTaxID(this.state.tax_id)
      this.setState({ company_name: '' })
    } else {
      this.setState({ requireTax: true })
    }
  }

  onFormSubmit = e => {
    this.setState({ requireActive: true })
    const {
      tax_id,
      company_name,
      contact_address,
      contact_country,
      time_zone,
      phone,
      fax,
      email,
      webbsite,
      supplier_portal,
      admin_buyer_full_name,
      admin_buyer_email,
      admin_buyer_license,
    } = this.state

    let data = {
      tax_id: trimmedString(tax_id),
      company_name: trimmedString(company_name),
      contact_address: trimmedString(contact_address),
      contact_country: parseInt(contact_country.id, 10),
      time_zone: time_zone.value,
      phone: trimmedString(phone),
      fax: trimmedString(fax),
      email: trimmedString(email),
      website: trimmedString(webbsite),
      supplier_portal: trimmedString(supplier_portal),
      admin_buyer_full_name: trimmedString(admin_buyer_full_name),
      admin_buyer_email: trimmedString(admin_buyer_email),
      admin_buyer_license:
        trimmedString(admin_buyer_license) === ''
          ? admin_buyer_license.trim()
          : parseInt(admin_buyer_license),
    }

    if (
      this.state.admin_buyer_emailValid &&
      this.state.emailValid &&
      data.phone !== '' &&
      data.contact_address &&
      data.contact_country &&
      data.time_zone &&
      data.email !== '' &&
      data.supplier_portal !== '' &&
      data.admin_buyer_full_name &&
      data.admin_buyer_email &&
      data.admin_buyer_license
    ) {
      this.setState({ formValid: true, loadingPage: true })
      this._fetchcreateBuyer(data)
    } else {
      this.setState({ formValid: false, loadingPage: false })
    }
  }

  render() {
    const {
      optionsCountry,
      optionsCountry_time_zone,
      isEditPageState,
      tax_id,
      company_name,
      contact_address,
      phone,
      email,
      supplier_portal,
      admin_buyer_full_name,
      admin_buyer_email,
      admin_buyer_license,
      canSave,
      emailValidate,
      admin_buyer_emailValie,
      admin_buyer_licenseValidate,
      tax_idValidate,
      requireActive,
      checkTax,
      requireTax,
      isVerifyLoading,
      loading,
    } = this.state
    return (
      <BuyerDetailFormStyle>
        {/* PAGE TITLE
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_buyer_management"
                src={ICONS['icon-user-white.svg']}
                alt="page icon"
              />
            </Section>

            <Section className="title-and-breadcrumb">
              <Section id="page_title_buyer_management" className="title">
                {STRING.BUYER_MANAGEMENT}
              </Section>

              <Section
                id="page_breadcrumb_buyer_management"
                className="breadcrumbs"
              >
                <Button
                  onClick={() => {
                    this.props.history.push(ROUTE_PATH.HOME.LINK)
                  }}
                  className="breadcrumb"
                >
                  <span>{STRING.HOME}</span>
                </Button>

                <Button
                  onClick={() => {
                    this.props.history.push(ROUTE_PATH.BUYER_MANAGEMENT.LINK)
                  }}
                  className="breadcrumb"
                >
                  <span>{STRING.BUYER_MANAGEMENT}</span>
                </Button>

                <Button className="breadcrumb current">
                  <span>Create Buyer</span>
                </Button>
              </Section>
            </Section>
          </Section>
        </Section>

        {/* PAGE CONTENT
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="main-content form">
          <Section className="content-body">
            <Section className="form-wrapper">
              {this.state.loadingPage ? (
                <Section className="loading">
                  <Spinner />
                </Section>
              ) : (
                <React.Fragment>
                  <Section className="form-group-title">Create Buyer</Section>

                  <Section
                    className={
                      'form-group' +
                      ((tax_id.trim() === '' && requireActive) ||
                      (tax_id.trim() === '' && requireTax)
                        ? ' is-error'
                        : !checkTax
                        ? ' is-error'
                        : !tax_idValidate && requireActive
                        ? ' is-error'
                        : ' ')
                    }
                  >
                    <label>Tax ID</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          onChange={this.handleUserInput}
                          name="tax_id"
                          value={tax_id}
                        />

                        <Button
                          className="theme-blue verify"
                          onClick={e => this.Verify()}
                        >
                          {!isVerifyLoading ? (
                            'Verify'
                          ) : (
                            <span className="loader" />
                          )}
                        </Button>
                      </Section>

                      <Section className="message">
                        {(tax_id.trim() === '' && requireActive) ||
                        (tax_id.trim() === '' && requireTax)
                          ? STRING.INVALID
                          : !checkTax
                          ? STRING.TAX_CHECK
                          : !tax_idValidate && requireActive
                          ? STRING.TAX_INVALID
                          : ''}
                      </Section>
                    </Section>
                  </Section>
                  <Section className="form-group">
                    <label>Company Name</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          disabled={true}
                          value={company_name}
                        />
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>
                  <Section className="form-row">
                    {/* {isEditPageState && (
                  <Section className="form-col col-6">
                    <Section className="form-group-header">
                      Registered Address
                    </Section>

                    <Section className="form-group">
                      <label>Address</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <InputTextarea
                            disabled={true}
                            value={
                              '90 CW Tower A , 31st Floor, Ratchadaphisek Rd., Huai Khwang, Bangkok 10310'
                            }
                          />
                        </Section>

                        <Section className="message"></Section>
                      </Section>
                    </Section>

                    <Section className="form-group">
                      <label>Country</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <SelectBox
                            id="active_status_filter"
                            defaultValue={optionsCountry[0]}
                            options={optionsCountry}
                            isSearchable={false}
                            isClearable={false}
                            isDisabled={true}
                          />
                        </Section>

                        <Section className="message"></Section>
                      </Section>
                    </Section>
                  </Section>
                )} */}

                    <Section className="form-col col-6">
                      <Section className="form-group-header grid-to-label">
                        Contact Address
                      </Section>

                      <Section
                        className={
                          'form-group' +
                          (contact_address.trim() === '' && requireActive
                            ? ' is-error'
                            : '')
                        }
                      >
                        <label>Address</label>

                        <Section className="form-group-control">
                          <Section className="form-group-inner-wrapper">
                            <InputTextarea
                              onChange={this.handleUserInput}
                              name="contact_address"
                              value={contact_address}
                              style={
                                contact_address.trim() === '' && requireActive
                                  ? true
                                  : false
                              }
                            />
                          </Section>

                          <Section className="message">
                            {contact_address.trim() === '' && requireActive
                              ? STRING.INVALID
                              : ''}
                          </Section>
                        </Section>
                      </Section>

                      <Section className={'form-group'}>
                        <label>Country</label>

                        <Section className="form-group-control">
                          <Section className="form-group-inner-wrapper">
                            <SelectBox
                              id="active_status_filter"
                              value={this.state.contact_country}
                              options={optionsCountry}
                              isSearchable={false}
                              isClearable={false}
                              name="contact_country"
                              onChange={this.handleUserDropdown}
                              defaultValue={this.state.contact_country}
                            />
                          </Section>
                          <Section className="message">{''}</Section>
                        </Section>
                      </Section>
                      <Section className={'form-group'}>
                        <label>TimeZone (UTC)</label>

                        <Section className="form-group-control">
                          <Section className="form-group-inner-wrapper">
                            <SelectBox
                              id="active_status_filter"
                              value={this.state.time_zone}
                              options={optionsCountry_time_zone}
                              isSearchable={false}
                              isClearable={false}
                              name="contact_country_timezone"
                              onChange={this.onClickDropdownTimeZone}
                              defaultValue={
                                this.state.optionsCountry_time_zone[0]
                              }
                            />
                          </Section>
                          <Section className="message">{''}</Section>
                        </Section>
                      </Section>
                    </Section>
                  </Section>
                  <Section
                    className={
                      'form-group' +
                      (phone.trim() === '' && requireActive ? ' is-error' : '')
                    }
                  >
                    <label>Phone</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          onChange={this.handleUserInput}
                          name="phone"
                          value={phone}
                        />
                      </Section>

                      <Section className="message">
                        {phone.trim() === '' && requireActive
                          ? STRING.INVALID
                          : ''}
                      </Section>
                    </Section>
                  </Section>
                  <Section className="form-group">
                    <label>
                      Fax <br /> (Optional)
                    </label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          onChange={this.handleUserInput}
                          name="fax"
                          value={this.state.fax}
                        />
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>
                  <Section
                    className={
                      'form-group' +
                      (this.state.emailValid
                        ? ''
                        : this.state.formValid
                        ? ''
                        : ' is-error')
                    }
                  >
                    <label>Email</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          onChange={this.handleUserInput}
                          name="email"
                          className={
                            this.state.emailValid
                              ? ''
                              : this.state.formValid
                              ? ''
                              : 'is-error'
                          }
                          value={this.state.email}
                        />
                      </Section>

                      {this.state.email === '' && (
                        <Section className="message">{STRING.INVALID}</Section>
                      )}
                      {!this.state.emailValid && this.state.email !== '' && (
                        <Section className="message">
                          {STRING.EMAIL_INVALID}
                        </Section>
                      )}

                      {this.state.emailValid && this.state.email !== '' && (
                        <Section className="message">{''}</Section>
                      )}
                    </Section>
                  </Section>
                  <Section className={'form-group'}>
                    <label>
                      Website <br /> (Optional)
                    </label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          onChange={this.handleUserInput}
                          name="webbsite"
                          value={this.state.webbsite}
                        />
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>
                  <Section
                    className={
                      'form-group' +
                      (supplier_portal.trim() === '' && requireActive
                        ? ' is-error'
                        : '')
                    }
                  >
                    <label>
                      Supplier Portal <br /> (URL)
                    </label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          onChange={this.handleUserInput}
                          name="supplier_portal"
                          value={supplier_portal}
                        />
                      </Section>

                      <Section className="message">
                        {supplier_portal.trim() === '' && requireActive
                          ? STRING.INVALID
                          : ''}
                      </Section>
                    </Section>
                  </Section>
                  <Section className="form-group-header">Buyer Admin</Section>
                  <Section
                    className={
                      'form-group' +
                      (admin_buyer_full_name.trim() === '' && requireActive
                        ? ' is-error'
                        : '')
                    }
                  >
                    <label>Full Name</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          onChange={this.handleUserInput}
                          name="admin_buyer_full_name"
                          value={admin_buyer_full_name}
                        />
                      </Section>

                      <Section className="message">
                        {admin_buyer_full_name.trim() === '' && requireActive
                          ? STRING.INVALID
                          : ''}
                      </Section>
                    </Section>
                  </Section>
                  <Section
                    className={
                      'form-group' +
                      (this.state.admin_buyer_emailValid
                        ? ''
                        : this.state.formValid
                        ? ''
                        : ' is-error')
                    }
                  >
                    <label>Email</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          onChange={this.handleUserInput}
                          name="admin_buyer_email"
                          value={admin_buyer_email}
                          className={
                            this.state.admin_buyer_emailValid
                              ? ''
                              : this.state.formValid
                              ? ''
                              : 'is-error'
                          }
                        />
                      </Section>

                      {this.state.admin_buyer_email === '' && (
                        <Section className="message">{STRING.INVALID}</Section>
                      )}
                      {!this.state.admin_buyer_emailValid &&
                        this.state.admin_buyer_email !== '' && (
                          <Section className="message">
                            {STRING.EMAIL_INVALID}
                          </Section>
                        )}

                      {this.state.admin_buyer_emailValid &&
                        this.state.admin_buyer_email !== '' && (
                          <Section className="message">{''}</Section>
                        )}
                    </Section>
                  </Section>
                  <Section
                    className={
                      'form-group' +
                      (admin_buyer_license === '' && requireActive
                        ? ' is-error'
                        : !admin_buyer_licenseValidate && requireActive
                        ? ' is-error'
                        : '')
                    }
                  >
                    <label>
                      No. of <br /> license user
                    </label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          onChange={this.handleUserInput}
                          name="admin_buyer_license"
                          value={admin_buyer_license}
                        />

                        {isEditPageState && (
                          <Section className="note">
                            {/* (No. of license users: 10/15) */}
                          </Section>
                        )}
                      </Section>

                      <Section className="message">
                        {admin_buyer_license === '' && requireActive
                          ? STRING.INVALID
                          : !admin_buyer_licenseValidate && requireActive
                          ? STRING.NO_INVALID
                          : ''}
                      </Section>
                    </Section>
                    {
                      isEditPageState && ''
                      // <Section className="form-group">
                      //   <label>Active</label>

                      //   <Section className="form-group-control">
                      //     <Section className="form-group-inner-wrapper">
                      //       <Switcher
                      //         onChange={this.handleChange}
                      //         checked={isActive}
                      //       />
                      //     </Section>

                      //     <Section className="message"></Section>
                      //   </Section>
                      // </Section>
                    }
                    <Section className="form-actions">
                      <Button
                        className="theme-border-gray"
                        onClick={() => {
                          this.props.history.push(
                            ROUTE_PATH.BUYER_MANAGEMENT.LINK
                          )
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        className="theme-green"
                        onClick={() => {
                          company_name.trim() === '' && canSave === false
                            ? ''
                            : this.onFormSubmit()
                        }}
                        disabled={
                          company_name.trim() === '' && canSave === false
                            ? true
                            : false
                        }
                      >
                        Save
                      </Button>
                    </Section>
                  </Section>
                </React.Fragment>
              )}
            </Section>
          </Section>
        </Section>
      </BuyerDetailFormStyle>
    )
  }
}
